// Compatibility shim for the legacy react-redux-toastr `actions.add(...)` API.
// The codebase dispatches Redux-style toast actions everywhere; under
// react-toastify we just call `toast.*` imperatively. This shim returns a
// thunk so old `dispatch(actions.add({...}))` call sites keep working without
// edits, and a noop action so Redux devtools log a sensible event.
import { toast, type Id } from 'react-toastify';

type ToastrType = 'success' | 'error' | 'warning' | 'info' | 'light';

interface ToastrPayload {
	message: string;
	type?: ToastrType;
	title?: string;
	options?: Record<string, unknown>;
}

const noop = { type: '@@toastr/noop' as const };

const dispatchToast = (payload: ToastrPayload): Id => {
	const text = payload.title ? `${payload.title}: ${payload.message}` : payload.message;
	switch (payload.type) {
		case 'success':
			return toast.success(text);
		case 'error':
			return toast.error(text);
		case 'warning':
			return toast.warning(text);
		case 'info':
			return toast.info(text);
		default:
			return toast(text);
	}
};

export const actions = {
	add: (payload: ToastrPayload) => () => {
		dispatchToast(payload);
		return noop;
	}
};
